import api from './api';

export const vehicleService = {
  async getVehicles(params = {}) {
    const response = await api.get('/vehicles', { params });
    return response.data;
  },
  
  async getVehicleById(id) {
    const response = await api.get(`/vehicles/${id}`);
    return response.data;
  },
  
  async createVehicle(vehicleData) {
    const response = await api.post('/vehicles', vehicleData);
    return response.data;
  },
  
  async updateVehicle(id, vehicleData) {
    const response = await api.put(`/vehicles/${id}`, vehicleData);
    return response.data;
  },
  
  async deleteVehicle(id) {
    const response = await api.delete(`/vehicles/${id}`);
    return response.data;
  },
  
  async toggleVehicleStatus(id, isActive) {
    const response = await api.patch(`/vehicles/${id}/status`, { isActive });
    return response.data;
  },
  
  async getVehiclesByCarrier(carrierId, params = {}) {
    const response = await api.get(`/vehicles/carrier/${carrierId}`, { params });
    return response.data;
  },
  
  async getVehiclesByType(typeId, params = {}) {
    const response = await api.get(`/vehicles/type/${typeId}`, { params });
    return response.data;
  },
  
  async uploadVehiclePhoto(id, formData) {
    const response = await api.post(`/vehicles/${id}/photos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  
  async uploadDriverPhoto(id, formData) {
    const response = await api.post(`/vehicles/${id}/driver-photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  
  async getVehicleTypes() {
    const response = await api.get('/vehicle-types');
    return response.data;
  }
};
